import { Injectable, Inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { RoleService } from '../service';

@Injectable({
  providedIn: 'root'
})
export class GetRolesResolver implements Resolve<any> {

  constructor(private roleService: RoleService) { }

  resolve() {
    return this.roleService.load(false, false);
  }
}
